import {createAction} from "redux-actions";

export const clearStyle = createAction('CLEAR_STYLE');
export const clearStyles = createAction('CLEAR_STYLES');
export const saveScrollpos = createAction('SAVE_SCROLLPOS_ACTION');
export const requestFailed = createAction("REQUEST_FAILED");
export const requestStarted = createAction("REQUEST_STARTED");
export const requestSucceeded = createAction("REQUEST_SUCCEEDED");
export const didReceiveStyles = createAction("RECEIVE_STYLES");
export const didReceiveStyle = createAction("RECEIVE_STYLE");






// WEBPACK FOOTER //
// ./app/client/style/actions.ts